export default [
  {
    path: '/',
    name: '主页'
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/errorPage/404'),
    hidden: true
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]



// WEBPACK FOOTER //
// ./src/router/baseRouter.js